import { Icon } from "armstrong-react";
import React from "react";
import { Control, Fieldset } from "react-redux-form";

import { CheckBox, Errors } from "../../../../../core/atoms/rrf";
import { CommonProps, Validators } from "./../common";
import { EmailField } from "./emailField";
import { PasswordField } from "./passwordField";

const required = Validators.required;

interface AccountFormProps {
  model: string;
  dispatch: any;
}

export class CreateAccount extends React.Component<CommonProps & AccountFormProps> {
  public constructor(props) {
    super(props);
    this.state = {
      showPasswords: false,
    };
  }

  public render() {
    const { model, formState } = this.props;

    // If required for this country, phone number appears in main form body.
    const showPhoneOptIn = !(formState.location && formState.location.enquiryOptions.phoneNumberRequired);

    return (
      <Fieldset model={model} className="account-create">
        <label>
          <span className="label">First name</span>
          <Control.text model=".firstName" label="First name" validators={{ required }} validateOn="blur" autoComplete="given-name" placeholder="e.g. Alex" />
          <Errors model=".firstName" messages={{ required: "Please enter your first name" }} />
        </label>

        <label>
          <span className="label">Family name</span>
          <Control.text model=".lastName" validators={{ required }} validateOn="blur" autoComplete="family-name" placeholder="e.g. Smith" />
          <Errors model=".lastName" messages={{ required: "Please enter your family name" }} />
        </label>

        <EmailField {...this.props} />

        <PasswordField {...this.props} name="Password" passwordModel=".password" validators={{ required }} errorsObject={{
          required: "Please enter a password"
        }} />

        <PasswordField {...this.props} name="Confirm password" passwordModel=".passwordConfirmation" errorsObject={{
          passwordsMatch: "Type your password again"
        }} />

        {showPhoneOptIn &&
          <div className="optin-wrap phone">
            <Icon icon={Icon.Icomoon.phoneIncoming} />
            <CheckBox
              id="enquire2-phoneoptin"
              model=".phoneOptIn"
              label="Would you like a phone call about your enquiry?"
              subLabel="We'll do our best to call you soon after we receive your enquiry."
            />

            {formState.account.phoneOptIn &&
              <label className="tel-input-wrap">
                <span className="label">Your phone number (include international dialling code)</span>
                <Control.text model=".phoneNumber" type="tel" autoComplete="tel" placeholder="e.g. +44 (0)117 325 7898" />
              </label>
            }
          </div>
        }

        <div className="optin-wrap newsletter">
          <Icon icon={Icon.Icomoon.envelop5} />
          <CheckBox
            id="enquire2-emailoptin"
            model=".marketingOptIn"
            label="Would you like to receive the TravelLocal newsletter?"
            subLabel="We'll email you information about new destinations, special offers, and inspiration for your travels."
          />
        </div>
      </Fieldset>
    );
  }
}

export class LoginAccount extends React.Component<CommonProps & AccountFormProps> {
  public render() {
    return (
      <Fieldset model={this.props.model} className="account-login">
        <EmailField {...this.props} />
        <PasswordField {...this.props} name="Password" passwordModel=".password" validators={{ required }} errorsObject={{
          required: "Please enter your password",
          signInFailed: "Please check your password",
        }} />
      </Fieldset>
    );
  }
}
